export default class {
	constructor(form, options = {}) {
		this.options = {
			fieldWrapSelector: ".validation-wrap",
			...options,
		};

		this.form = form;

		this.refresh();

		this.form.addEventListener("submit", this.handleSubmit.bind(this));
	}

	refresh() {
		this.fields = this.form.querySelectorAll("input");

		for (const field of this.form.querySelectorAll("input[data-equals]")) {
			this.setupEqualFieldValidity(field);
		}

		for (const field of this.fields) {
			if ("radio" === field.type) {
				field.addEventListener("change", this.handleBlur.bind(this));
			} else {
				field.addEventListener("blur", this.handleBlur.bind(this));
				field.addEventListener("input", this.handleInput.bind(this));
			}
		}
	}

	handleBlur(e) {
		if ("false" === e.target.dataset.autoValidate) {
			return;
		}

		this.validateField(e.target);
	}

	handleInput(e) {
		if (e.target.validity.customError && e.target.customErrorShown) {
			e.target.setCustomValidity("");
			e.target.customErrorShown = false;
		}
	}

	validateField(field, customMessage = false) {
		const isValid = field.disabled ? true : field.validity.valid;

		const wrap = field.closest(this.options.fieldWrapSelector);

		if (!wrap) {
			return;
		}

		const errorElements = wrap.querySelectorAll(".validation-error");

		for (const errorElement of errorElements) {
			errorElement.classList.remove("visible");
		}

		if (false === isValid) {
			wrap.classList.add("invalid");
		} else {
			wrap.classList.remove("invalid");
		}

		if (!isValid) {
			for (const error in field.validity) {
				if ("valid" === error) {
					continue;
				}

				if (true === field.validity[error]) {
					this.displayValidationError(field, wrap, error, customMessage);

					if ("function" === typeof this.options.invalidCallback) {
						this.options.invalidCallback(field, this, error);
					}

					break;
				}
			}
		} else if ("function" === typeof this.options.validCallback) {
			this.options.validCallback(field, this);
		}

		if ("function" === typeof this.options.callback) {
			this.options.callback(field, this, isValid);
		}
	}

	setError(field, errorCode, isError = true) {
		if (false === isError) {
			if (field.validity[errorCode]) {
				field.setCustomValidity("");
				delete field.validity[errorCode];

				this.validateField(field);
			}
		} else {
			field.setCustomValidity(errorCode);
			field.validity[errorCode] = true;
		}
	}

	setCustomError(field, message, display = true) {
		field.setCustomValidity("custom");

		if (true === display) {
			this.validateField(field, message);
		}
	}

	displayValidationError(field, wrap, error, customMessage = false) {
		const type = customMessage ? "custom" : error;
		const typedErrorElement = wrap.querySelector(`[data-type="${type}"]`);

		if (customMessage && typedErrorElement) {
			typedErrorElement.innerText = customMessage;
		}

		const errorElement =
			typedErrorElement || wrap.querySelector(`[data-type="generic"]`);

		if (errorElement) {
			errorElement.classList.add("visible");
		}

		if ("custom" === type) {
			field.customErrorShown = true;
		}
	}

	setupEqualFieldValidity(field) {
		const equalField = document.getElementById(field.dataset.equals);

		const validate = () => {
			field.validity.notEqual = field.value && field.value !== equalField.value;
			const message = field.validity.notEqual ? "notEqual" : "";

			field.setCustomValidity(message);
		};

		field.addEventListener("input", validate);
		equalField.addEventListener("input", validate);
		equalField.addEventListener("blur", () => this.validateField(field));
	}

	isValid() {
		return this.form.checkValidity();
	}

	handleSubmit(e) {
		if (e.target.checkValidity()) {
			return;
		}

		e.preventDefault();

		this.fullFormCheck = true;

		for (const field of this.fields) {
			this.validateField(field);
		}

		this.fullFormCheck = false;
	}
}
